<template>
    <div>
    </div>
</template>

<script>
  export default {
    methods: {
      async trackAd() {
        var url = window.location.href;

        if (url.indexOf('?') !== -1) {

          var trackingParams = url.split('?')[1];
          var paramsArray = trackingParams.split('&');
          var trackingData = {};

          for (var i = 0; i < paramsArray.length; i++) {
            var param = paramsArray[i].split('=');
            trackingData[param[0]] = param[1];
          }

          const baseurl = window.location.href.split('?')[0];
          trackingData['landing_url'] = baseurl;

          const res = await axios.post('/ads-tracking', trackingData);
          if(res.status == 200){
            window.history.replaceState({}, '', baseurl);
          }
        }
      }
    },
    async mounted () {
      await this.trackAd();
    }
  };
</script>
